import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public Server = 'read from app settings';
    // File server not used anymore...
    public FileServer = 'read from app settings';
}


// WEBPACK FOOTER //
// ./angularApp/app/app.constants.ts